<template>
  <el-card class="tempContainer">
    <div class="templateTop">
      <span class="tips"></span>
      <div class="searchTool">
        <el-button @click="saveTemplateId" type="primary">添加模板</el-button>
      </div>
    </div>
    <div class="chooseTempBox">
      <div class="tempItem" v-for="(item, index) in tempOptions" :key="index">
        <div class="flex">
          <p>{{ item.name }}</p>
          <el-button
            type="text"
            icon="el-icon-edit"
            @click="editName(item)"
          ></el-button>
          <el-button
            type="text"
            icon="el-icon-delete"
            @click="deleteBtn(item.id)"
          ></el-button>
        </div>
        <el-upload
          class="upload-demo"
          action=""
          :http-request="amountFileUploadRequest.bind(null, index)"
          :show-file-list="false"
        >
          <img
            :src="
              item.url ||
              'http://68wx--test.oss-cn-hangzhou.aliyuncs.com/tkwx/16275259264812422462480.jpg'
            "
            alt=""
          />
        </el-upload>

        <el-button @click="goEditPage(item.id)">编辑模板</el-button>
      </div>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      style="margin-top: 20px; text-align: right"
      :total="page.total"
      :page-size="page.pageSize"
      :current-page="page.pageNumber"
      @current-change="currentChange"
    >
    </el-pagination>
  </el-card>
</template>
<script>
import { uploadOSS } from "../../upload/upload";
export default {
  data() {
    return {
      page: {
        total: 0,
        pageSize: 3,
        pageNumber: 1,
      },
      tempOptions: [],
    };
  },
  methods: {
    deleteBtn(id) {
      this.$confirm("是否删除该模板?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.wxSchoolPageTemplate
            .deleteWxSchoolPageTemplate([
              {
                id,
              },
            ])
            .then((res) => {
              this.$message.success("删除成功");
              this.getSchoolPageTemplatePageList();
            });
        })
        .catch(() => {});
    },
    editName(item) {
      this.$prompt("请输入模板名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (value) {
            item.name = value;
            this.updateSchoolPageTemplate(item);
          } else {
            this.$message.error("请输入模板名称");
          }
        })
        .catch(() => {});
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.getSchoolPageTemplatePageList();
    },
    // 获取模板列表
    getSchoolPageTemplatePageList() {
      this.api.wxSchoolPageTemplate
        .pageList({
          pageSize: this.page.pageSize,
          pageNumber: this.page.pageNumber,
        })
        .then((res) => {
          this.tempOptions = res.data.records;
          this.page.total = res.data.total;
        });
    },
    // 添加模板（弹窗）
    saveTemplateId() {
      this.$prompt("请输入模板名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          this.addSchoolPageTemplate(value);
        })
        .catch(() => {});
    },
    // 添加模板
    addSchoolPageTemplate(value) {
      this.api.wxSchoolPageTemplate
        .addWxSchoolPageTemplate({ name: value })
        .then((res) => {
          this.getSchoolPageTemplatePageList();
        });
    },
    // ---------------------------------清除缓存
    delRedis() {
      this.api.schoolPage.delRedis().then((res) => {
        if (res.success) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 修改模板
    goEditPage(id) {
      const { href } = this.$router.resolve({
        path: "/design",
        query: {
          id,
        },
      });
      window.open(href, "_blank");
    },
    amountFileUploadRequest(index, file) {
      const isJPG = file.file.type.indexOf("image") > -1;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
        return;
      }
      if (file.file.size / 1024 / 1024 > 1) {
        this.$message.error("图片大小不能超过1M");
      } else {
        uploadOSS(file, "agentInfo").then((result) => {
          this.tempOptions[index].url = result;
          this.updateSchoolPageTemplate(this.tempOptions[index]);
          this.$message.success("操作成功");
        });
      }
    },
    updateSchoolPageTemplate(obj) {
      this.api.wxSchoolPageTemplate.updateWxSchoolPageTemplate(obj);
    },
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    },
  },
  mounted() {
    this.getSchoolPageTemplatePageList();
  },
};
</script>

<style lang="less" scoped>
.templateTop {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 20px;
}
.tempContainer {
  padding-bottom: 60px;
}
.chooseTempBox {
  display: flex;
  flex-direction: row;
  padding: 0 127px;
  justify-content: space-around;
  .tempItem {
    display: flex;
    flex-direction: column;
    align-content: center;
    .flex {
      display: flex;
      justify-content: center;
      p {
        font-weight: 700;
        font-style: normal;
        font-size: 16px;
        color: #455a64;
        margin-bottom: 10px;
      }
      i {
        font-size: 16px;
      }
      .el-button {
        width: auto;
        height: auto;
        margin-left: 10px;
        margin-right: 0;
      }
    }

    img {
      width: 300px;
      height: 300px;
    }
    .el-button {
      width: 300px;
      height: 40px;
      margin: 0 auto;
      margin-top: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/designPage/index.vue